import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { PixelRatio, StyleSheet, Text, View, } from 'react-native';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export const SccButton = ({ type = 'regular', buttonColor, borderColor, width, height, text, textColor = 'white', fontSize = 16, fontFamily = font.pretendardRegular, fontWeight = 'normal', isDisabled = false, onPress = () => { }, style = {}, rightLabel, rightLabelColor = 'white', rightLabelSize = 14, leftIcon: LeftIcon, rightIcon: RightIcon, iconSize = 20, iconColor, elementName, logParams, }) => {
    const finalIconColor = iconColor || textColor;
    return (_jsxs(SccTouchableOpacity, { elementName: elementName, logParams: Object.assign({ button_text: text }, logParams), onPress: isDisabled ? () => { } : onPress, activeOpacity: isDisabled ? 0.4 : 0.7, style: [
            buttonStyles(buttonColor, isDisabled, width, height, borderColor)[type],
            style,
        ], children: [_jsxs(View, { style: { flexDirection: 'row', alignItems: 'center', gap: 6 }, children: [LeftIcon && (_jsx(LeftIcon, { width: iconSize, height: iconSize, color: color[isDisabled ? 'gray30' : finalIconColor] })), _jsx(Text, { style: textStyles(isDisabled ? 'gray30' : textColor, fontSize, fontFamily, fontWeight).text, children: text }), RightIcon && (_jsx(RightIcon, { width: iconSize, height: iconSize, color: color[isDisabled ? 'gray30' : finalIconColor] }))] }), rightLabel && (_jsx(Text, { style: [
                    textStyles(rightLabelColor, rightLabelSize, font.pretendardMedium, fontWeight).text,
                    { position: 'absolute', right: 20 },
                ], children: rightLabel }))] }));
};
const defaultButton = {
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
};
const buttonStyles = (buttonColor = 'blue50', isDisabled, _width = 'auto', _height = 54, borderColor) => StyleSheet.create({
    regular: Object.assign(Object.assign({}, defaultButton), { width: _width, height: _height, backgroundColor: isDisabled ? color.gray15 : color[buttonColor], borderWidth: borderColor ? 1 : 0, borderColor: borderColor
            ? isDisabled
                ? color.gray15
                : color[borderColor]
            : 'undefined' }),
    text: Object.assign({}, defaultButton),
});
const textStyles = (textColor, _fontSize, _fontFamily, _fontWeight) => StyleSheet.create({
    text: {
        color: color[textColor],
        fontSize: (_fontSize !== null && _fontSize !== void 0 ? _fontSize : 0) / PixelRatio.getFontScale(), // 버튼 텍스트를 고정 크기로 설정한다.
        fontFamily: _fontFamily,
        fontWeight: _fontWeight,
        lineHeight: ((_fontSize !== null && _fontSize !== void 0 ? _fontSize : 0) / PixelRatio.getFontScale()) * 1.3,
        includeFontPadding: false, // Android에서 폰트 상하 여백 제거
        textAlignVertical: 'center', // Android에서 텍스트 수직 정렬
    },
});
